import Tags from '@/views/admin/tags'
import TagSave from '@/views/admin/tags/Save'

export const tags = [
  {
    path: 'tags/list',
    component: Tags,
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  },
  {
    name: 'admin_tags_save',
    path: 'tags/save/:id?/:name?',
    component: TagSave,
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/tags.js